import { render, staticRenderFns } from "./basicModule.vue?vue&type=template&id=43701379&scoped=true&"
import script from "./basicModule.vue?vue&type=script&lang=js&"
export * from "./basicModule.vue?vue&type=script&lang=js&"
import style0 from "./basicModule.vue?vue&type=style&index=0&id=43701379&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43701379",
  null
  
)

export default component.exports